<template>
  <div class="property-filter-popover">
    <div>
      <div v-if="!isDesktop" class="property-filter-popover--header">
        <h1>Filter</h1>
        <span class="property-filter-popover--close" @click="setShowFilters(false)">
          <LsIcon type="close" />
        </span>
      </div>
      <div :class="['property-filter-popover--checkboxes', { 'no-border': !isDesktop }]">
        <span v-if="!isDesktop">Status</span>
        <LsCheckboxes
          v-model="tempFilter"
          track-id="property_filter_popover-status_filter"
          :options="statusOptions"
          name="tempFilter"
          test-id="checkboxes"
        />
      </div>
    </div>
    <div>
      <LsButton
        bg-color="primary-light"
        track-id="property_filter_popover-clear"
        text="clear"
        text-color="primary"
        :min-width="false"
        @click="clearFilter"
      />
      <LsButton
        track-id="property_filter_popover-save"
        text="save"
        :min-width="false"
        @click="saveFilter"
      />
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapMutations, mapState } from 'vuex';
import { LsCheckboxes, LsButton, LsIcon } from '@/components/common';
import { PROPERTY_MANAGER__MUTATE_FILTER } from '@/store/types';

export default {
  name: 'PropertyFilterPopover',
  components: { LsCheckboxes, LsButton, LsIcon },
  props: {
    isDesktop: VueTypes.bool.isRequired,
    changePage: VueTypes.func.isRequired,
    setShowFilters: VueTypes.func.isRequired,
  },
  data() {
    return { filter: [], tempFilter: [] };
  },
  computed: {
    ...mapState(['propertyManager']),
    statusOptions() {
      return [{ label: 'Active', value: 'active' }, { label: 'Inactive', value: 'inactive' }];
    },
  },
  created() {
    this.filter = this.propertyManager.filter;
    this.tempFilter = this.propertyManager.filter;
  },
  methods: {
    ...mapMutations([PROPERTY_MANAGER__MUTATE_FILTER]),
    saveFilter() {
      this.filter = this.tempFilter;
      this.updateFilter(this.filter);
    },
    clearFilter() {
      this.tempFilter = [];
      this.filter = [];
      this.updateFilter([]);
    },
    updateFilter(filter) {
      this.setShowFilters(false);
      this.changePage(1);

      this[PROPERTY_MANAGER__MUTATE_FILTER](filter);
    },
  },
};
</script>

<style lang="scss" scoped>
.property-filter-popover {
  pointer-events: auto;
  position: absolute;
  top: 180px;
  left: 82px;
  padding: 20px;
  width: 320px;
  border: 1px solid $primary-light;
  background-color: $white;
  z-index: $z-index-property-manager-view-overlay;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .property-filter-popover--header {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid $primary-light;
    padding-bottom: 20px;
    margin-top: 0;
    padding-top: 0;

    .property-filter-popover--close {
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .property-filter-popover--checkboxes {
    border-bottom: 1px solid $primary-light;
    padding-bottom: 20px;

    > span {
      padding-bottom: 16px;
      font-weight: bold;
      display: block;
    }

    &.no-border {
      border: none;
      padding-top: 20px;
    }
  }

  > div:last-of-type {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;

    @media (max-width: $mobile-max-width) {
      justify-content: space-between;
      padding-top: 12px;
    }

    > button {
      width: 100px;

      @media (max-width: $mobile-max-width) {
        width: 100%;
      }

      &:first-of-type {
        margin-right: 10px;
      }
    }
  }

  @media (max-width: $mobile-max-width) {
    top: 0px;
    left: 0px;
    width: 100%;
    /* need to subtract the top margin from PropertyManangerView container */
    height: calc(100vh - 110px);
    padding-top: 0;
    box-shadow: none;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.themed-app {
  .property-filter-popover {
    border-color: $theme-color-primary-light;
    background-color: $theme-color-white;

    .property-filter-popover--header {
      border-color: $theme-color-primary-light;
    }

    .property-filter-popover--checkboxes {
      border-color: $theme-color-primary-light;
    }
  }
}
</style>
